module.exports = __webpack_public_path__ + "static/media/XMR.56762996.svg";